import React from "react";

// Types
import ModalButton from "../../types/ModalButton";

// Components
import Button from "../Button/Button";
import ButtonLink from "../Button/ButtonLink";

export const ModalButtons = (props: any) => (
  <>
    {props.buttons.map((button: ModalButton, key: number) => {
      const { to, onClick, ...buttonProps } = button;
      return to ? <ButtonLink {...{ key, to, ...buttonProps }} /> : <Button {...{ key, onClick: () => onClick!(props.field), ...buttonProps }} />;
    })}
  </>
);
